import { createContext, useEffect, useState } from 'react'

import { IDashboardStatistics } from '../../sdk/traceability/traceability.types'
import { sdk } from '../../services/sdk'

interface DashboardDataContext {
  statistics?: IDashboardStatistics

  actions: {
    getBrandsStatistics: (startDate?: string, endDate?: string) => Promise<void>
  }
}

interface DashboardProviderProps {
  children: React.ReactNode
}

export const DashboardContext = createContext({} as DashboardDataContext)

export function DashboardProvider(props: DashboardProviderProps) {
  const [statistics, setStatistics] = useState<IDashboardStatistics>()

  const getBrandsStatistics = async () => {
    try {
      const response = await sdk.traceability.dashboardStatistics()
      setStatistics(response)
    } catch (error) {
      console.error(error)
    }
  }

  useEffect(() => {
    getBrandsStatistics()
  }, [])

  return (
    <DashboardContext.Provider
      value={{
        statistics,

        actions: {
          getBrandsStatistics,
        },
      }}
    >
      {props.children}
    </DashboardContext.Provider>
  )
}
